import config from '@/config';
import { fetchData } from '@/model/utils/fetch';
import { chunk } from '@/utils/lodash-alternatives';

const CHUNK_SIZE = 50;

export const fetchLiveTables = async (
  tableIds: string[],
  currency?: string
) => {
  try {
    const tableIdsChunks = chunk(tableIds, CHUNK_SIZE);
    const res = await Promise.all(
      tableIdsChunks.map(chunkIds =>
        fetchData<{
          [key: string]: any;
        }>({
          url: `${config.urls.bffBaseUrl}/game-tables`,
          queryParameters: {
            game: chunkIds,
            currency,
          },
        })
      )
    );

    return Object.assign({}, ...res);
  } catch (err) {
    console.error(
      `There was a problem while fetching Live Tables. ${config.urls.bffBaseUrl}/game-tables`
    );
    console.error(err);

    return {};
  }
};
